import { ReactElement } from "react";
import { HiXMark } from "react-icons/hi2";

import Button from "@/components/atoms/Button";

type Props = {
  featuredIcon: React.ReactNode;
  heading: string;
  body?: string | ReactElement;
  children?: React.ReactNode;
  preventClose?: boolean;
  onClose: (value: boolean) => void;
};

const BasicModalContent = ({
  featuredIcon,
  heading,
  body,
  children,
  preventClose = false,
  onClose,
  ...props
}: Props) => {
  return (
    <div {...props}>
      <div className={"mb-4 flex justify-between"}>
        {featuredIcon}

        {!preventClose && (
          <div>
            <Button
              onClick={() => onClose(false)}
              className={"!p-1"}
              leadingIcon={<HiXMark className={"size-6 shrink-0 text-fg-quinary"} />}
              color={"natural"}
              variants={"text"}
              size={"xs"}
            />
          </div>
        )}
      </div>
      <div className={"mb-6 grid gap-1"}>
        <h2 className={"text-xl font-semibold text-primary"}>{heading}</h2>
        {body && <p className={"text-sm text-quaternary"}>{body}</p>}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default BasicModalContent;
